"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _BlockComponent = _interopRequireDefault(require("../BlockComponent"));

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _CreateOutlined = _interopRequireDefault(require("@material-ui/icons/CreateOutlined"));

var _reactI18next = require("react-i18next");

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var BlockItem = function BlockItem(_ref) {
  var handleSave = _ref.handleSave,
      _ref$editPageOpen = _ref.editPageOpen,
      editPageOpen = _ref$editPageOpen === void 0 ? false : _ref$editPageOpen,
      config = _ref.config,
      key = _ref.key;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var _useState = (0, _react.useState)(editPageOpen),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      showEditPage = _useState2[0],
      setShowEditPage = _useState2[1];

  var handleClose = function handleClose() {
    return setShowEditPage(false);
  };

  var handleOpen = function handleOpen() {
    return setShowEditPage(true);
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
      className: _styleModule.default.block,
      onClick: handleOpen,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _styleModule.default.blockImage,
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "46.588",
          height: "54.29",
          viewBox: "0 0 46.588 54.29",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
            transform: "translate(0 0)",
            children: [' ', /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              fill: "#7ad651",
              d: "M519.472,300.92a24.189,24.189,0,0,0-13.509,2.18,22.311,22.311,0,0,0-11.443,14.87c-.7,2.711-1.435,5.413-2.153,8.119-.3,1.141-.659,2.272-.888,3.427-.182.916.11,1.213,1.039,1.239s1.87,0,2.8.013c.348,0,.732-.037.929.368l.254.257a1.569,1.569,0,0,1,.188,1.1c.008,3.164,0,6.328.006,9.492,0,1.744.595,2.322,2.342,2.321,2.421,0,4.842-.012,7.263,0,1.634.011,2.159.555,2.163,2.2.006,2.421,0,8.5,0,8.5l20.575-3.394v-9.356a2.584,2.584,0,0,1,.9-2.091c.52-.489,1.029-.992,1.515-1.514a23.5,23.5,0,0,0,6.3-12.9A21.018,21.018,0,0,0,534.4,310.5a22.114,22.114,0,0,0-11.35-8.731C522.251,301.495,519.656,300.95,519.472,300.92Z",
              transform: "translate(-491.428 -300.722)"
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            transform: "translate(25.747 0.008)",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              fill: "rgba(2,44,73,0.12)",
              d: "M493.725,300.92a20.473,20.473,0,0,0-2.3-.19l.077,52.814,11.792-1.926v-9.356a2.584,2.584,0,0,1,.9-2.091c.52-.489,1.029-.992,1.515-1.514a23.5,23.5,0,0,0,6.3-12.9,21.018,21.018,0,0,0-3.361-15.258,22.114,22.114,0,0,0-11.35-8.731C496.5,301.495,493.909,300.95,493.725,300.92Z",
              transform: "translate(-491.428 -300.73)"
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
            transform: "translate(11.633 4.71)",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              fill: "#fff",
              d: "M230.015,145.331a6.429,6.429,0,0,1-3.223,5.576l-.325,2.711-2.885,2.061-.009.006-2.877-2.067-.325-2.711a6.432,6.432,0,0,1,3.211-12.007h.034a6.432,6.432,0,0,1,6.4,6.431Z",
              transform: "translate(-209.525 -130.929)"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              fill: "#fff",
              d: "M267.41,63.341v1.29a1.55,1.55,0,0,1-1.541,1.551h-.009a1.551,1.551,0,0,1-1.551-1.551v-1.29a1.551,1.551,0,0,1,1.551-1.551h.009A1.551,1.551,0,0,1,267.41,63.341Z",
              transform: "translate(-251.812 -61.79)"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              fill: "#fff",
              d: "M146.258,181.8h-1.291a1.551,1.551,0,1,0,0,3.1h1.291a1.551,1.551,0,1,0,0-3.1Z",
              transform: "translate(-143.417 -169.396)"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              fill: "#dadfe3",
              d: "M375.417,181.8h-1.291a1.551,1.551,0,0,0,0,3.1h1.291a1.551,1.551,0,1,0,0-3.1Z",
              transform: "translate(-348.887 -169.396)"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              fill: "#fff",
              d: "M177.544,99.855a1.551,1.551,0,1,0-2.192,2.193l.913.912a1.551,1.551,0,0,0,2.192-2.193Z",
              transform: "translate(-171.644 -95.513)"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              fill: "#dadfe3",
              d: "M348.457,99.856a1.551,1.551,0,0,0-2.193,0l-.913.912a1.551,1.551,0,0,0,2.192,2.193l.913-.912A1.551,1.551,0,0,0,348.457,99.856Z",
              transform: "translate(-324.07 -95.514)"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              fill: "#dadfe3",
              d: "M279.4,66.181V61.79a1.551,1.551,0,0,1,1.541,1.551v1.29A1.55,1.55,0,0,1,279.4,66.181Z",
              transform: "translate(-265.342 -61.79)"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              fill: "#dadfe3",
              d: "M285.832,145.331a6.429,6.429,0,0,1-3.223,5.576l-.325,2.711-2.885,2.061V138.9h.034a6.432,6.432,0,0,1,6.4,6.431Z",
              transform: "translate(-265.342 -130.929)"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              fill: "#63A888",
              d: "M257.25,281.28l-.269,2.242a2.634,2.634,0,0,1-2.616,2.322h0a2.635,2.635,0,0,1-2.617-2.322l-.268-2.242Z",
              transform: "translate(-240.309 -258.591)"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              fill: "#336950",
              d: "M282.284,281.28l-.269,2.242a2.634,2.634,0,0,1-2.616,2.322V281.28Z",
              transform: "translate(-265.342 -258.591)"
            })]
          })]
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        children: t(config.translations.description)
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.default, {
        "aria-label": "Open",
        color: "inherit",
        className: _styleModule.default.openBlockIcon,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CreateOutlined.default, {})
      })]
    }), showEditPage && /*#__PURE__*/(0, _jsxRuntime.jsx)(_BlockComponent.default, {
      config: config,
      open: showEditPage,
      handleClose: handleClose,
      handleSave: handleSave
    }, "".concat(key, "-overlay"))]
  });
};

var _default = /*#__PURE__*/(0, _react.memo)(BlockItem);

exports.default = _default;